/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Copy_RawInputs */



/**
* | output |
* | --- |
* | "Copy raw markdown" |
*
* @param {Editor_Copy_RawInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_copy_raw = /** @type {((inputs?: Editor_Copy_RawInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Copy_RawInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Rohes Markdown kopieren")
	return /** @type {LocalizedString} */ ("Copy raw markdown")
});